<template>
  <div ref="chart" :id="id" :style="{ minHeight: `${height}px`, height: `${height}px`, width: `${resolveWidth}` }"></div>
</template>

<script setup lang="ts">
import type { EChartsOption } from 'echarts';

import useCustomChart from './hooks/useCustomChart';

import { computed } from 'vue';

const resolveHeight = computed(() => {
  return props.responsiveHeight ? '100%' : typeof props.height === 'number' ? `${props.height}px` : props.height;
});

const resolveWidth = computed(() => {
  return props.responsiveWidth ? '100%' : typeof props.width === 'number' ? `${props.width}px` : props.width;
});

interface Props {
  options: EChartsOption;
  height?: number | string;
  width?: number | string;
  rawData?: Charts.ChartsProps.RawData;
  colorList?: Charts.ChartsProps.ColorItem[];
  responsiveWidth?: boolean;
  responsiveHeight?: boolean;
  eventType?: string;
  function?: Function;
}

const props = withDefaults(defineProps<Props>(), {
  options: undefined,
  height: 100,
  width: 200,
  rawData: undefined,
  colorList: undefined,
  responsiveWidth: false,
  responsiveHeight: false,
  eventType: 'dbClick',
  function: () => {},
});

const { id, chart, calculateWidth } = useCustomChart(props);
</script>
